module.exports = __webpack_public_path__ + "static/media/EstefaniaDeRosa_cv_es.7f2200e2.pdf";